import { render, staticRenderFns } from "./gs-toggle-value.vue?vue&type=template&id=0fdd7f3d&scoped=true"
import script from "./gs-toggle-value.vue?vue&type=script&lang=ts"
export * from "./gs-toggle-value.vue?vue&type=script&lang=ts"
import style0 from "./gs-toggle-value.vue?vue&type=style&index=0&id=0fdd7f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd7f3d",
  null
  
)

export default component.exports